import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import metricsService from "../../services/metrics.service";
import { useEffect, useState } from "react";
import { useStore } from "../../store";
import { toast } from "../../components/Toast";
import PageLoader from "../../components/PageLoader";
import AppSidebar from "../../components/AppSidebar/AppSidebar";

interface MetricsDataType {
  public_url: string;
}

export default function Metrics() {
  const { dispatch } = useStore();
  const [data, setData] = useState<MetricsDataType | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    async function getMetricsData() {
      try {
        const metricsData = await metricsService.getDataDogData();
        setData(metricsData.data.details);
      } catch (error: any) {
        let errorMsg =
          error?.response?.data?.error?.message ||
          "Failed to fetch metrics api data";
        toast.error(dispatch, errorMsg);
      } finally {
        setIsLoading(false);
      }
    }
    getMetricsData();
  }, []);
  const [tabValue, setTabValue] = useState("API-Metrics");

  const handleTabChange = (newValue: string) => {
    setTabValue(newValue);
  };
 return (
    <Box sx={{ display: "flex" }}>
      <AppSidebar/>
      <Box style={{ width: "100%" }}>
        <Toolbar
          sx={{ borderBottom: "1px solid #cdcdcd", gap: "2%" }}
          variant="dense"
        >
          <Typography variant="h6">API Metrics</Typography>
        </Toolbar>
        {isLoading ? (
          <PageLoader />
        ) : (
          <iframe
            title="Metrics Dashboard"
            src={data?.public_url || ""}
            width="100%"
            height="600px"
            frameBorder="0"
          ></iframe>
        )}
      </Box>
    </Box>
  );
}
